import {remote} from '../constants/environment';
import {IStandardServiceResponse} from '../interfaces/services/standard-service.interface';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const postAppointConfirmation = async (
  code: string,
  appointmentId: string,
  token: string,
): Promise<IStandardServiceResponse> => {
  const remoteURI = remote.getSalesmanScheduleUri();

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'POST',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
        body: JSON.stringify({
          payload: {
            code,
            appointmentId,
          },
        }),
      });
    },
    async (response: Response) => {
      if (response.status === 200) {
        const json = await response.json();

        const {success} = json;
        if (success) {
          return {
            success: true,
            payload: {},
          };
        }
      }
    },
    remoteURI,
  )) as IStandardServiceResponse;
};
